
// eslint-disable-next-line import/prefer-default-export
export enum DisplayType {
	BLOCK = 'block',
	INLINE = 'inline',
}
